import React from 'react';
import classnames from 'classnames';
import LoadingIndicator from '../../../LoadingIndicator';
import { useDeviationViewContext } from '../../../Context';
import s from './DeviationPageLoader.scss';
export const DeviationPageLoader = ()=>{
    const { isFullscreen } = useDeviationViewContext();
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isFullscreen && s['fullscreen'])
    }, /*#__PURE__*/ React.createElement(LoadingIndicator, {
        view: "llama",
        className: s['lloader']
    }));
};
DeviationPageLoader.displayName = 'DeviationPageLoader';
export default DeviationPageLoader;
